<style lang="scss">
.inner-shadow {
  -webkit-box-shadow: inset -42px 0px 46px -35px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: inset -42px 0px 46px -35px rgba(0, 0, 0, 0.25);
  box-shadow: inset -42px 0px 46px -35px rgba(0, 0, 0, 0.25);
}

.version {
  font-size: 14px;
}
</style>

<template>
  <div>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Aguarde...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-app id="inspire">
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        color="primary"
        dark
        app
        class="inner-shadow"
      >
        <v-row
          class="text-center white--text mt-3"
          style="height: 80px"
          align="center"
          no-gutters
        >
          <v-col>
            <h1>
              <v-img
                src="@/assets/logo_light.svg"
                height="50"
                contain
                alt="Brastop"
                class="text-center"
              ></v-img>
            </h1>
            <span class="text-center font-weight-thin white--text version">
              v{{ $store.getters.getAppVersion }}
            </span>
          </v-col>
        </v-row>
        <v-divider class="mt-2"></v-divider>
        <v-list dense>
          <div class="text-center mt-5 mb-3">
            <Avatar
              :avatar_url="user.avatar"
              :user_name="user.name"
              size="80"
              :user_id="user.sub"
              font_size="20"
            />
          </div>
          <!-- <v-row no-gutters>
            <v-col class="text-center">
              <v-btn color="primary lighten-5" icon class="mr-0">
                <v-icon>mdi-account</v-icon>
              </v-btn>
              <v-btn color="primary lighten-5" icon>
                <v-icon>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-col>
          </v-row> -->
          <v-menu :close-on-content-click="true" bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on">
                <v-list-item-content>
                  <v-list-item-title>{{ user.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-card>
              <v-list dense>
                <v-list-item to="perfil">
                  <v-list-item-icon>
                    <v-icon>mdi-account-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Meu perfil</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item to="/login">
                  <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-list>
        <v-divider></v-divider>
        <v-list nav dense>
          <template>
            <v-list-item link to="/">
              <v-list-item-action>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Painel</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/pedidos">
              <v-list-item-action>
                <v-icon>mdi-order-bool-descending-variant</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Pedidos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/devolucoes">
              <v-list-item-action>
                <v-icon>mdi-keyboard-return</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Devoluções</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/clientes">
              <v-list-item-action>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Clientes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/produtos">
              <v-list-item-action>
                <v-icon>mdi-package-variant-closed</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Produtos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item link to="/relogio_de_ponto">
              <v-list-item-action>
                <v-icon>mdi-clock-fast</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Relógio de Ponto</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item link to="/users" v-if="user.admin">
              <v-list-item-action>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Usuários</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/authorized_devices" v-if="user.admin">
              <v-list-item-action>
                <v-icon>mdi-tablet-cellphone</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Dispositivos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <v-btn block text to="/login">
              <v-icon left>mdi-power</v-icon>Sair
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <!-- <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app elevation="4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
          <span>BRASTOP</span>
        </v-toolbar-title>
      </v-app-bar> -->
      <v-main style="background-color: #f1f1f1">
        <v-app-bar
          :clipped-left="$vuetify.breakpoint.lgAndUp"
          elevation="0"
          color="#f1f1f1"
        >
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
          <v-toolbar-title
            v-if="$vuetify.breakpoint.smAndDown"
            style="width: 300px"
            class="ml-0 pl-4"
          >
            <span>BRASTOP</span>
          </v-toolbar-title>
        </v-app-bar>
        <v-container fluid>
          <router-view></router-view>
          <ConfirmDialog />
        </v-container>
      </v-main>
      <v-snackbar
        v-model="snackbar.active"
        :timeout="10000"
        center
        top
        :color="snackbar.color || ''"
      >
        {{ snackbar.text }}
        <!-- <v-btn color="white" text @click="closeSnack">Fechar</v-btn> -->
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
import ConfirmDialog from "@/components/tools/ConfirmDialog";

export default {
  name: "HelloWorld",
  components: { Avatar, ConfirmDialog },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      { icon: "mdi-view-dashboard", text: "Dashboard", link: "/" },
      {
        icon: "mdi-account-group",
        text: "Usuários",
        link: "/users",
        admin: true
      }
    ]
  }),
  methods: {
    closeSnack() {
      this.$store.commit("closeMessage");
    }
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    user() {
      return this.$store.getters.getUser;
    },
    snackbar() {
      return this.$store.getters.getSnackbar;
    }
  }
};
</script>
